import { useState } from "react";
import { useSimpleRequest, useTypedSelector } from "hooks";
import { selectTransaction } from "features/transactions/selectors";
import { useTransactionContext } from "../TransactionProvider";

export const useTransactionAction = () => {
    const transaction = useTypedSelector(
        selectTransaction(useTransactionContext(), {})
    );

    const [isLoading, setLoading] = useState(false);

    const request = useSimpleRequest({ setLoading });

    return {
        transaction,
        isLoading,
        request
    };
};

export default useTransactionAction;
